import { CLOUDFRONT_URL } from '#base/core/consts/aws';

export const cdnUrl = (path: string) => {
	return `${CLOUDFRONT_URL}/${path}`;
};
